import {
  GET_CONTACT,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_ERROR,
  GET_CONTACT_INFORMATION,
  GET_CONTACT_INFORMATION_SUCCESS,
  GET_CONTACT_INFORMATION_ERROR,
  TOGGLE_CREATE_CONTACT_INFORMATION_PANEL,
  TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS,
  GET_PRIMARY_CONTACT_METHODS,
  GET_PRIMARY_CONTACT_METHODS_SUCCESS,
  GET_PRIMARY_CONTACT_METHODS_ERROR,
  GET_CONTACT_METHOD_TYPES,
  GET_CONTACT_METHOD_TYPES_SUCCESS,
  GET_CONTACT_METHOD_TYPES_ERROR,
  GET_CONTACT_USERNAME_EXIST,
  GET_CONTACT_USERNAME_EXIST_SUCCESS,
  GET_CONTACT_USERNAME_EXIST_ERROR,
  GET_CONTACT_TERMS,
  GET_CONTACT_TERMS_SUCCESS,
  GET_CONTACT_TERMS_ERROR,
  GET_CONTACT_TERMS_SUFFIX,
  GET_CONTACT_TERMS_SUFFIX_SUCCESS,
  GET_CONTACT_TERMS_SUFFIX_ERROR,
  CREATE_CONTACT_INFORMATION,
  CREATE_CONTACT_INFORMATION_SUCCESS,
  CREATE_CONTACT_INFORMATION_ERROR,
  GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY,
  CREATE_USER_ACCOUNT,
  CREATE_USER_ACCOUNT_SUCCESS,
  CREATE_USER_ACCOUNT_ERROR,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_CONTACT_DETAILS_STATE,
  UPDATE_CONTACT,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_ERROR
} from "../actions";

export const getContact = (contactId, verbType, activityInfo) => ({
  type: GET_CONTACT,
  payload: { contactId, verbType, activityInfo },
});

export const getContactSuccess = (contactData) => ({
  type: GET_CONTACT_SUCCESS,
  payload: contactData,
});

export const getContactError = (message) => ({
  type: GET_CONTACT_ERROR,
  payload: { message },
});

export const updateContact = (contact) => ({
  type: UPDATE_CONTACT,
  payload: { contact },
});

export const updateContactSuccess = (contactData) => ({
  type: UPDATE_CONTACT_SUCCESS,
  payload: contactData,
});

export const updateContactError = (message) => ({
  type: UPDATE_CONTACT_ERROR,
  payload: { message },
});

export const getContactUserName = (userName, activityInfo) => ({
  type: GET_CONTACT_USERNAME_EXIST,
  payload: { userName, activityInfo },
});

export const getContactUserNameSuccess = (isValidUserName) => ({
  type: GET_CONTACT_USERNAME_EXIST_SUCCESS,
  payload: isValidUserName,
});

export const getContactUserNameError = (message) => ({
  type: GET_CONTACT_USERNAME_EXIST_ERROR,
  payload: { message },
});

export const getNameTitleTerms = (vocabularyName) => ({
  type: GET_CONTACT_TERMS,
  payload: { vocabularyName },
});

export const getNameTitleTermsSuccess = (contactTerms) => ({
  type: GET_CONTACT_TERMS_SUCCESS,
  payload: contactTerms,
});

export const getNameTitleTermsError = (message) => ({
  type: GET_CONTACT_TERMS_ERROR,
  payload: { message },
});

export const getNameSuffixTerms = (vocabularyName) => ({
  type: GET_CONTACT_TERMS_SUFFIX,
  payload: { vocabularyName },
});

export const getNameSuffixTermsSuccess = (contactTerms) => ({
  type: GET_CONTACT_TERMS_SUFFIX_SUCCESS,
  payload: contactTerms,
});

export const getNameSuffixTermsError = (message) => ({
  type: GET_CONTACT_TERMS_SUFFIX_ERROR,
  payload: { message },
});

export const getContactMethodTypes = (activityInfo) => ({
  type: GET_CONTACT_METHOD_TYPES,
  payload: { activityInfo },
});

export const getContactMethodTypesSuccess = (contactMethodTypes) => ({
  type: GET_CONTACT_METHOD_TYPES_SUCCESS,
  payload: contactMethodTypes,
});

export const getContactMethodTypesError = (message) => ({
  type: GET_CONTACT_METHOD_TYPES_ERROR,
  payload: { message },
});

export const getPrimaryContactMethods = (contactId, activityInfo) => ({
  type: GET_PRIMARY_CONTACT_METHODS,
  payload: { contactId, activityInfo },
});

export const getPrimaryContactMethodsSuccess = (primaryContactMethodData) => ({
  type: GET_PRIMARY_CONTACT_METHODS_SUCCESS,
  payload: primaryContactMethodData,
});

export const getPrimaryContactMethodsError = (message) => ({
  type: GET_PRIMARY_CONTACT_METHODS_ERROR,
  payload: { message },
});

export const toggleContactInformationPanel = (
  isAdd,
  selectedTermId,
  selectedContactMethods
) => ({
  type: TOGGLE_CREATE_CONTACT_INFORMATION_PANEL,
  payload: { isAdd, selectedTermId, selectedContactMethods },
});

export const toggleContactInformationPanelSuccess = (addEditContactInfo) => ({
  type: TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS,
  payload: addEditContactInfo,
});

export const getContactInformation = (contactId, activityInfo) => ({
  type: GET_CONTACT_INFORMATION,
  payload: { contactId, activityInfo },
});

export const getContactInformationSuccess = (contactInformation) => ({
  type: GET_CONTACT_INFORMATION_SUCCESS,
  payload: contactInformation,
});

export const getContactInformationError = (message) => ({
  type: GET_CONTACT_INFORMATION_ERROR,
  payload: { message },
});

export const createContactInformation = (contactId, addEditContactInfo, isPageRefresh, activityInfo) => ({
  type: CREATE_CONTACT_INFORMATION,
  payload: { contactId, addEditContactInfo, isPageRefresh, activityInfo },
});

export const createContactInformationSuccess = (contactInformation) => ({
  type: CREATE_CONTACT_INFORMATION_SUCCESS,
  payload: contactInformation,
});

export const createContactInformationError = (message) => ({
  type: CREATE_CONTACT_INFORMATION_ERROR,
  payload: { message },
});

export const getStateProvincesForSelectedCountry = (selectedCountryId) => ({
  type: GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY,
  payload: { selectedCountryId },
});

export const createUserAccount = (user, activityInfo) => ({
  type: CREATE_USER_ACCOUNT,
  payload: { user, activityInfo },
});

export const createUserAccountSuccess = (successMessage, userName, userAccountType) => ({
  type: CREATE_USER_ACCOUNT_SUCCESS,
  payload: { successMessage, userName, userAccountType },
});

export const createUserAccountError = (message) => ({
  type: CREATE_USER_ACCOUNT_ERROR,
  payload: { message },
});

export const changeUserPassword = (user, activityInfo) => ({
  type: CHANGE_USER_PASSWORD,
  payload: { user, activityInfo },
});

export const changeUserPasswordSuccess = (successMessage) => ({
  type: CHANGE_USER_PASSWORD_SUCCESS,
  payload: successMessage,
});

export const changeUserPasswordError = (message) => ({
  type: CHANGE_USER_PASSWORD_ERROR,
  payload: { message },
});

export const updateContactDetailsState = (updatedValues) => ({
  type: UPDATE_CONTACT_DETAILS_STATE,
  payload: { updatedValues },
});

export const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: { user },
});

export const updateUserSuccess = (successMessage) => ({
  type: UPDATE_USER_SUCCESS,
  payload: { successMessage },
});

export const updateUserError = (message) => ({
  type: UPDATE_USER_ERROR,
  payload: { message },
});

export const deleteUser = (userName, activityInfo) => ({
  type: DELETE_USER,
  payload: { userName, activityInfo },
});

export const deleteUserSuccess = (successMessage) => ({
  type: DELETE_USER_SUCCESS,
  payload: { successMessage },
});

export const deleteUserError = (message) => ({
  type: DELETE_USER_ERROR,
  payload: { message },
});
